import React, { useEffect, useState } from "react";
import { PlusOutlined } from "@ant-design/icons";
import TaskCard from "./TaskCard";
import { useDroppable } from "@dnd-kit/core";
import InfiniteScroll from "react-infinite-scroll-component";
import apiClient from "utils/apiClient";
import { PM_SERVICE_BASE_URL } from "constants";
import { Spin } from "antd";

const KanbanColumn = ({
  column,
  tasks,
  fetchMoreTasks,
  hasMore,
  onTaskClick,
  onEditTask,
  onDelete,
  onAssigneeClick,
}) => {
  const { setNodeRef } = useDroppable({
    id: column.key, // column becomes drop target
  });

  // console.log(column.key, hasMore);

  return (
    <div ref={setNodeRef} className="kanban-column">
      <div className="column-header">
        <div className="column-title">
          <span className="status-dot" style={{ background: column.dot }} />
          <h6 className="fw-bold mb-0 pb-0 text-xxs">{column.title}</h6>
          <span className="task-count">{tasks.length}</span>
        </div>

        <PlusOutlined className="column-add" />
      </div>

      <div id={`scrollable-${column.key}`} className="column-content">
        <InfiniteScroll
          dataLength={tasks.length}
          next={fetchMoreTasks}
          hasMore={hasMore}
          loader={
            <div
              style={{ display: "flex", justifyContent: "center", padding: 12 }}
            >
              <Spin size="small" />
            </div>
          }
          scrollableTarget={`scrollable-${column.key}`}
        >
          {tasks.map((task) => (
            <TaskCard
              key={task.id}
              task={task}
              onClick={() => onTaskClick(task)}
              onEditTask={onEditTask}
              onDelete={onDelete}
              onAssigneeClick={onAssigneeClick}
            />
          ))}
        </InfiniteScroll>
      </div>
    </div>
  );
};

export default KanbanColumn;
